// extracted by mini-css-extract-plugin
module.exports = {"group":"RadiogroupWidget_group__2J3s4"};